module.exports = __webpack_public_path__ + "img/s_4.ea2f41ec.png";